export default __webpack_public_path__ + "static/LeituraSansTwo-BlackItalic-b5a7fb69d443df2f562f83e3c3f3bb3a.woff";